if (!customElements.get('back-in-stock-form')) {
  customElements.define(
    'back-in-stock-form',
    class BackInStockForm extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        this.input = this.querySelector('input[type="email"]');
        this.submitButton = this.querySelector('button[type="submit"]');
        this.spinner = this.querySelector('.loading__spinner');
        this.successMessage = this.querySelector('.back-in-stock__message--success');
        this.errorMessage = this.querySelector('.back-in-stock__message--error');
        this.form?.addEventListener('submit', this.onSubmit.bind(this));
        if (this.submitButton) this.submitButton.disabled = false;
      }

      get companyId() {
        if (this.dataset.companyId) return this.dataset.companyId;
        const onsiteScript = document.querySelector('script[src*="static.klaviyo.com/onsite/js/"]');
        const match = onsiteScript?.src.match(/onsite\/js\/([^/]+)\//);
        return match?.[1] ?? '';
      }

      async onSubmit(event) {
        event.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        const email = this.input.value.trim();
        if (!email || !this.input.checkValidity()) {
          this.input.setAttribute('aria-invalid', 'true');
          this.input.focus();
          return;
        }
        this.input.removeAttribute('aria-invalid');
        this.setLoading(true);
        this.errorMessage.hidden = true;

        try {
          const response = await fetch(
            `https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=${encodeURIComponent(this.companyId)}`,
            {
              method: 'POST',
              headers: { revision: '2025-01-15', 'content-type': 'application/vnd.api+json' },
              body: JSON.stringify(this.buildPayload(email)),
            }
          );
          if (!response.ok) throw new Error(`Klaviyo responded with ${response.status}`);
          this.showSuccess();
        } catch (error) {
          this.errorMessage.hidden = false;
          this.setLoading(false);
        }
      }

      buildPayload(email) {
        return {
          data: {
            type: 'back-in-stock-subscription',
            attributes: {
              profile: { data: { type: 'profile', attributes: { email } } },
              channels: ['EMAIL'],
            },
            relationships: {
              variant: {
                data: { type: 'catalog-variant', id: `$shopify:::$default:::${this.dataset.variantId}` },
              },
            },
          },
        };
      }

      setLoading(isLoading) {
        this.submitButton.toggleAttribute('aria-disabled', isLoading);
        this.submitButton.classList.toggle('loading', isLoading);
        this.spinner?.classList.toggle('hidden', !isLoading);
      }

      showSuccess() {
        this.setLoading(false);
        this.input.readOnly = true;
        this.submitButton.hidden = true;
        this.successMessage.hidden = false;
      }
    }
  );
}
